import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetKnowledgebaseArticle Input Action
 */
export class GetKnowledgebaseArticleInput implements Msdyn365.IActionInput {
    public searchQuery: string;
    constructor(searchQuery: string) {
        this.searchQuery = searchQuery;
    }

    public getCacheKey = () => `GetKnowledgebaseArticlesKey-${this.searchQuery}`;
    public getCacheObjectType = () => 'GetKnowledgebaseArticles';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IGetKnowledgebaseArticleData {
    '@odata.context': string;
    value: IKnowledgebaseArticle[];
}

export interface IKnowledgebaseArticle {
    ArticlePublicNumber: string;
    Content: string;
    CreationDate: string;
    Description: string;
    Keywords: string;
    KnowledgeArticleId: string;
    KnowledgeArticleViews: string;
    PreviewContent: string;
    RatingCount: string;
    ReatingDate: string;
    StatusCode: string;
    Title: string;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetKnowledgebaseArticleInput('');
};

async function action(input: GetKnowledgebaseArticleInput, ctx: Msdyn365.IActionContext): Promise<IGetKnowledgebaseArticleData> {
    const userToken = ctx.requestContext.user.token === null ? 'USERTOKEN' : ctx.requestContext.user.token;

    const requestBody = { query: input.searchQuery, language: ctx.requestContext.locale };

    const response = await Msdyn365.sendRequest<IGetKnowledgebaseArticleData>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/SearchKnowledgeArticles`,
        'post',
        requestBody,
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${userToken}`
            }
        }
    );

    if (response.status === 200 && response.data) {
        return { ...response.data };
    }

    return { ...response.data };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetKnowledgebaseArticleData>>action,
    id: 'GetKnowledgebaseArticle',
    input: createInput
});
